import {
  SetAction,
  SetSalesReps,
  SetSourceUser,
  SetTargetUser,
} from './useReassignConnections.types'

export const setAction: SetAction = ({ action, set }) =>
  set && set(() => ({ action }))

export const setSalesReps: SetSalesReps = ({ salesReps, set }) =>
  set && set(() => ({ salesReps }))

export const setSourceUser: SetSourceUser = ({ sourceUser, set }) =>
  set && set(() => ({ sourceUser }))

export const setTargetUser: SetTargetUser = ({ targetUser, set }) =>
  set && set(() => ({ targetUser }))
